import React, { useState } from "react";
import styles from "./asset/PracticeModuleTool.module.scss";
import SystemPromptEditorTab from "./SystemPromptEditorTab";
import QuestionIdNavigatorTab from "./QuestionIdNavigatorTab";

const TAB_KEYS = {
    SYSTEM_PROMPT_EDITOR: "systemPromptEditor",
    QUESTION_ID_NAVIGATOR: "questionIdNavigator",
};

const PracticeModuleTool = ({
    sessionId,
    answerConfirmed = false,
    currentQuestionId = "",
    is25QuestionMode = false,
    answeredCount = 0,
    questionLimit = 25,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(TAB_KEYS.SYSTEM_PROMPT_EDITOR);
    const [hasCustomPrompt, setHasCustomPrompt] = useState(false);

    const openTool = () => setIsOpen(true);
    const closeTool = () => setIsOpen(false);

    return (
        <>
            <button
                className={styles.triggerBubble}
                onClick={openTool}
                type="button"
                title="Practice Module Tool"
                aria-label="Open Practice Module Tool"
            >
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M10.5 6H5.5C4.4 6 3.5 6.9 3.5 8V18C3.5 19.1 4.4 20 5.5 20H15.5C16.6 20 17.5 19.1 17.5 18V13"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8 10.75H13"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                    <path
                        d="M8 14H12"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                    <path
                        d="M18.2 4.8C18.6 4.4 19.2 4.4 19.6 4.8L21.2 6.4C21.6 6.8 21.6 7.4 21.2 7.8L15 14L12.5 14.5L13 12L18.2 4.8Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                {hasCustomPrompt && <span className={styles.customIndicator} aria-hidden="true" />}
            </button>

            {isOpen && (
                <div className={styles.modalLayer} role="dialog" aria-modal="true">
                    <div className={styles.backdrop} onClick={closeTool} />
                    <div className={styles.modalPanel}>
                        <div className={styles.modalHeader}>
                            <div>
                                <h3>Practice Module Tool</h3>
                                <p>Admin toolbox for prompt testing and question targeting</p>
                            </div>
                            <button
                                className={styles.closeButton}
                                onClick={closeTool}
                                type="button"
                                aria-label="Close Practice Module Tool"
                            >
                                x
                            </button>
                        </div>

                        <div className={styles.tabRow}>
                            <button
                                className={`${styles.tabButton} ${activeTab === TAB_KEYS.SYSTEM_PROMPT_EDITOR ? styles.tabActive : ""
                                    }`}
                                onClick={() => setActiveTab(TAB_KEYS.SYSTEM_PROMPT_EDITOR)}
                                type="button"
                            >
                                System Prompt Editor
                            </button>
                            <button
                                className={`${styles.tabButton} ${activeTab === TAB_KEYS.QUESTION_ID_NAVIGATOR ? styles.tabActive : ""
                                    }`}
                                onClick={() => setActiveTab(TAB_KEYS.QUESTION_ID_NAVIGATOR)}
                                type="button"
                            >
                                Question ID Navigator
                            </button>
                        </div>

                        <div className={styles.tabBody}>
                            {activeTab === TAB_KEYS.SYSTEM_PROMPT_EDITOR && (
                                <SystemPromptEditorTab
                                    sessionId={sessionId}
                                    answerConfirmed={answerConfirmed}
                                    onCustomPromptStateChange={setHasCustomPrompt}
                                />
                            )}
                            {activeTab === TAB_KEYS.QUESTION_ID_NAVIGATOR && (
                                <QuestionIdNavigatorTab
                                    currentQuestionId={currentQuestionId}
                                    is25QuestionMode={is25QuestionMode}
                                    answeredCount={answeredCount}
                                    questionLimit={questionLimit}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PracticeModuleTool;
